import { Type } from '@angular/core';
import { SerializedRouterStateSnapshot } from '@ngrx/router-store';
import { MenuItemName } from 'src/app/shared/page/menu.config';
import { CalistComponent } from 'src/app/features/calist/calist/calist.component';
import { CreateCaPageComponent } from 'src/app/features/calist/create-ca-page/create-ca-page.component';
import { CryptotokenlistComponent } from 'src/app/features/cryptotokenlist/cryptotokenlist/cryptotokenlist.component';
import { ProfilelistComponent } from 'src/app/features/profilelist/profilelist.component';
import { NewCryptotokenPageComponent } from 'src/app/features/cryptotokenlist/new-cryptotoken-page/new-cryptotoken-page.component';
import { CreateProfilePageComponent } from 'src/app/features/profilelist/create-profile-page/create-profile-page.component';
import { ProvisionOperationalCaPageComponent } from 'src/app/features/operational-list/provision-operational-ca-page/provision-operational-ca-page';

export interface PageConfig {
  pageName: string;
  menuItem: MenuItemName;
  pageComponent: Type<unknown>;
  routeTest: (routeState: SerializedRouterStateSnapshot) => boolean;
  defaultUrl: string;
  onlyEditor?: boolean;
  editorOnlyQueryParams?: string[];
}

export enum Page {
  CaList = 'CaList',
  CreateCa = 'CreateCa',
  Foo = 'Foo',
  CreateCryptotoken = 'CreateCryptotoken',
  CryptotokenList = 'CryptotokenList',
  ProfileList = 'ProfileList',
  CreateProfile = 'CreateProfile',
  ProvisionOperationalCa = 'ProvisionOperationalCa',
}

export const PAGES_CONFIG: PageConfig[] = [
  {
    pageName: Page.CaList,
    pageComponent: CalistComponent,
    defaultUrl: 'calist',
    routeTest: route =>
      route.url === '/calist' || route.url.startsWith('/calist?'),
    menuItem: MenuItemName.calist,
    editorOnlyQueryParams: ['edit'],
  },
  {
    pageName: Page.CreateCa,
    pageComponent: CreateCaPageComponent,
    defaultUrl: 'calist/create',
    routeTest: route => route.url === '/calist/create',
    menuItem: MenuItemName.calist,
    onlyEditor: true,
  },
  // {
  //   pageName: Page.Foo,
  //   pageComponent: FooComponent,
  //   defaultUrl: 'foo',
  //   routeTest: route => route.url === '/foo' || route.url.startsWith('/foo?'),
  //   menuItem: MenuItemName.foo,
  // },
  {
    pageName: Page.CryptotokenList,
    pageComponent: CryptotokenlistComponent,
    defaultUrl: 'cryptotokenlist',
    routeTest: route =>
      route.url === '/cryptotokenlist' ||
      route.url.startsWith('/cryptotokenlist?'),
    menuItem: MenuItemName.cryptotokenlist,
  },
  {
    pageName: Page.CreateCryptotoken,
    pageComponent: NewCryptotokenPageComponent,
    defaultUrl: 'cryptotokenlist/create',
    routeTest: route => route.url === '/cryptotokenlist/create',
    menuItem: MenuItemName.cryptotokenlist,
    onlyEditor: true,
  },
  {
    pageName: Page.ProfileList,
    pageComponent: ProfilelistComponent,
    defaultUrl: 'profilelist',
    routeTest: route =>
      route.url === '/profilelist' || route.url.startsWith('/profilelist?'),
    menuItem: MenuItemName.profilelist,
    editorOnlyQueryParams: ['edit', 'clone'],
  },
  {
    pageName: Page.CreateProfile,
    pageComponent: CreateProfilePageComponent,
    defaultUrl: 'profilelist/create',
    routeTest: route => route.url === '/profilelist/create',
    menuItem: MenuItemName.profilelist,
    onlyEditor: true,
  },
  {
    pageName: Page.ProvisionOperationalCa,
    pageComponent: ProvisionOperationalCaPageComponent,
    defaultUrl: 'provision-operational-ca',
    routeTest: route => route.url === '/provision-operational-ca',
    menuItem: MenuItemName.provisionOperationalCa,
    onlyEditor: true,
  },
];
